import { defineComponent, Types } from 'bitecs';

const Model = defineComponent({
  path: Types.i8,
  texture: Types.i8,
});

export { Model };
